import classNames from 'classnames';
import React, { useEffect, useRef, useState } from 'react';
import Icon, { COLORS, ICONS } from '../icon';
import { Tooltip } from '../tooltip/tooltip';

export interface SelectOption {
	icon?: any;
	label: any;
	value: string | number;
}
interface Props {
	label?: string;
	info?: string;
	options: SelectOption[];
	selected: string | number;
	onChange: (value: any, id?: any) => void;
	placeholder?: string;
	id?: any;
	disabled?: boolean;
	mainIcon?: any;
	small?: boolean;
	noMaxHeight?: boolean;
	ignoreSpacing?: boolean;
	ignorePositioning?: boolean;
	ignoreInlineStyling?: boolean;
	errorMessage?: string
}

export default function SelectInput(props: Props): JSX.Element {
	const { label, options, selected, onChange, placeholder, id, disabled = false, mainIcon, small, noMaxHeight, ignoreSpacing = false, ignorePositioning = false, ignoreInlineStyling = false, info, errorMessage } = props;
	const selector = useRef<HTMLDivElement | null>(null);
	const [selectedOption, setSelectedOption] = useState<SelectOption>(options.find((option: SelectOption) => option.value === selected) || options[0]);
	const [open, setOpen] = useState(false);
	const [left, setLeft] = useState(0);
	const [top, setTop] = useState(0);
	const [width, setWidth] = useState(100);

	function checkClick(e: any) {
		const path = e.path || e.composedPath();
		for (const item of path) {
			if (selector.current === item) { return; }
		}
		setOpen(false);
	}

	useEffect(() => {
		if (open) {
			window.addEventListener('click', checkClick);
		}

		return () => window.removeEventListener('click', checkClick);
	}, [open]);

	useEffect(() => {
		setSelectedOption(options.find((option: SelectOption) => option.value === selected)!);
		setOpen(false);
	}, [selected, options]);

	useEffect(() => {
		const rect = selector.current?.getBoundingClientRect();

		if (!ignorePositioning) {
			if (rect && !ignoreSpacing) {
				setLeft(rect.left ?? 0);
				setTop((rect.top ?? 0) + 30);
				setWidth(rect.width ?? 0);
			} else if (rect && ignoreSpacing) {
				setWidth(rect.width);
			}
		} else if (rect) {
			setWidth(rect.width);
		}

	}, [open, selector, ignoreSpacing, ignorePositioning]);

	return (
		<div ref={selector} className={classNames("field-group select", { disabled, small })} onClick={() => setOpen(true)}>
			{label && <label>
				{label}
				{info && (
					<Tooltip tooltip={info}>
						<Icon name={ICONS.PRIMARY_TOOLTIP} color={COLORS.CYAN} size={12} />
					</Tooltip>
				)}
			</label>}
			<div className={classNames("select-container", { error: errorMessage })}>
				<div className={classNames("selected-option", { placeholder: !selectedOption?.label })}>{selectedOption?.icon ? selectedOption.icon : null}{selectedOption?.label ?? placeholder}</div>

				<div className='select-dropdown-container'>
					<div
						className={classNames("select-dropdown", { open, noMaxHeight })}
						style={{
							...(ignoreInlineStyling ? {} : { left, top, width }),
							...(ignorePositioning ? { position: 'absolute' } : {})
						}}
					>
						{options.map((option: SelectOption) => (
							<div key={option.value} className="select-option" onClick={() => onChange(option.value, id)}><span>{option.label}</span></div>
						))}
					</div>
					{mainIcon && <span className="main-icon">{mainIcon}</span>}
				</div>
			</div>
			{errorMessage && <label className="error-message">{errorMessage}</label>}
		</div>
	);
}